import { render, staticRenderFns } from "./VVaultSelectorItem.vue?vue&type=template&id=60fb70c8&"
import script from "./VVaultSelectorItem.vue?vue&type=script&lang=ts&"
export * from "./VVaultSelectorItem.vue?vue&type=script&lang=ts&"
import style0 from "./VVaultSelectorItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports